export const VulnerabilitySeverityRegistry = {
  NOTE: 'NOTE',
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
  CRITICAL: 'CRITICAL'
}
export type VulnerabilitySeverity =
  (typeof VulnerabilitySeverityRegistry)[keyof typeof VulnerabilitySeverityRegistry]

export type VulnerabilitySeverityName =
  | 'CLEAN'
  | 'NOTE'
  | 'LOW'
  | 'MEDIUM'
  | 'HIGH'
  | 'CRITICAL'
  | 'UNKNOWN'

export class Severity {
  public static readonly CRITICAL: Severity = new Severity(
    'CRITICAL',
    'title_vulnSeverityTypeCritical'
  )
  public static readonly HIGH: Severity = new Severity(
    'HIGH',
    'title_vulnSeverityTypeHigh'
  )
  public static readonly MEDIUM: Severity = new Severity(
    'MEDIUM',
    'title_vulnSeverityTypeMedium'
  )
  public static readonly LOW: Severity = new Severity(
    'LOW',
    'title_vulnSeverityTypeLow'
  )
  public static readonly NOTE: Severity = new Severity(
    'NOTE',
    'title_vulnSeverityTypeNote'
  )
  public static readonly CLEAN: Severity = new Severity(
    'CLEAN',
    'title_vulnSeverityTypeClean'
  )
  public static readonly UNKNOWN: Severity = new Severity(
    'UNKNOWN',
    'title_unknown'
  )

  public static readonly all: Severity[] = [
    Severity.CRITICAL,
    Severity.HIGH,
    Severity.MEDIUM,
    Severity.LOW,
    Severity.NOTE,
    // Severities not returned by the BE
    Severity.CLEAN, // "clean" as there's no severity
    Severity.UNKNOWN // Private libraries
  ]

  public static fromName = (
    name: VulnerabilitySeverityName | VulnerabilitySeverity
  ): Severity => {
    const severity = Severity.all.find((severity) => severity.name === name)

    if (!severity) {
      throw new Error(`Unknown severity: ${name}`)
    }

    return severity
  }

  constructor(
    readonly name: VulnerabilitySeverityName,
    readonly i18nID: string
  ) {}
}
